import { useLayoutEffect } from 'react'
import { Spinner, Text, VisuallyHidden } from '@n26/nxd'
import { useDashboardStructure } from '@/features/dashboard/api/queries'
import { SectionGroup } from '@/features/dashboard/tiles/SectionGroup'
import { homeCardOf } from '@/features/dashboard/model/sections'
import {
  homeCardAnchor,
  scrollCardIntoView,
  takeReturn,
} from '@/features/dashboard/model/homeReturn'
import { tileButtonId } from '@/shared/lib/viewTransition'
import styles from './DashboardPage.module.css'

export const DashboardPage = () => {
  const { data: dashboard, isPending, isError } = useDashboardStructure()

  // Back from a deep dive: bring the card that links to it into view, before
  // the first paint, so the old deep dive offset is never seen.
  useLayoutEffect(() => {
    if (!dashboard) return
    const id = takeReturn()
    const home = id === null ? undefined : homeCardOf(dashboard.sections, id)
    if (!home) return
    const target =
      document.getElementById(homeCardAnchor(home.stub.cardId)) ??
      document.getElementById(tileButtonId(home.stub.cardId))
    if (target) scrollCardIntoView(target, { align: 'start' })
  }, [dashboard])

  if (isPending) {
    return (
      <div className={styles.status} role='status'>
        <Spinner />
        <VisuallyHidden>Loading</VisuallyHidden>
      </div>
    )
  }

  if (isError) {
    return (
      <div className={styles.status} role='alert'>
        <Text color='rhubarb'>Couldn&apos;t load the dashboard.</Text>
      </div>
    )
  }

  return (
    <div className={styles.page}>
      <VisuallyHidden as='h1'>Dashboard</VisuallyHidden>
      {dashboard.sections
        .filter(section => section.kind === 'section')
        .map(section => (
          <SectionGroup key={section.id} section={section} />
        ))}
    </div>
  )
}
